/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import log from 'salvo-lite/log'
import JsTabs from 'js-tabs/dist/main/index.js'

class ProductInfoTabs {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
    }

    onInit () {
        log.debug(this.constructor.name, 'initialised', this)

        const myTabs = new JsTabs({
            elm: '#production-information-tabs',
            shouldScrollTabIntoView: false
        })

        myTabs.init()
    }
}

export default ProductInfoTabs



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ProductInfoTabs.js